module.exports = __webpack_public_path__ + "static/img/arrow_right.1552b510.svg";